export async function waitForConditionAsync(checkFn, interval = 500) {
    while (!checkFn()) {
        await new Promise((resolve) => setTimeout(resolve, interval));
    }
}
